module.exports = __webpack_public_path__ + "static/media/pfp-becca.46c794eb.jpeg";